import {
    apiRequest,
    saudaraDetail,
    saudaraUpdate,
    masterRegion
} from "../../../../../../services/adapters/kepegawaian/saudaraService"

class UpdateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }
    
    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityDistrict = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityVillage= async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", saudaraDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", saudaraUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository